import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import SectionHead from '../components/SectionHead';
import StaffCard from '../components/StaffCard';
import ServiceCard from '../components/ServiceCard';
import CTASection from '../components/CTASection';
import { Reveal, SectionRule } from '../components/motion';
import { services, staffingServices } from '../data/mock';


const ServicesPage = () => (
  <>
    <Navbar />
    <main>
      <PageHero index="01" eyebrow="Services" title={['Everything IT,', 'under {{one roof.}}']}>
        Ten disciplines, one accountable partner. From the first firewall rule to the last Kubernetes pod.
      </PageHero>

      <SectionRule index="01" label="Services" />
      <section className="py-8">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-5">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 2) * 100} className={i % 2 ? 'md:mt-8' : ''}>
              <ServiceCard service={s} index={i} total={services.length} specs={5} className="h-full" />
            </Reveal>
          ))}
        </div>
      </section>

      <SectionRule index="02" label="IT as a service" />
      <section className="py-8 bg-[var(--surface)]">
        <div className="max-w-6xl mx-auto px-6">
          <SectionHead index="02" label="IT as a service" title="Talent that {{plugs straight in.}}">
            Certified engineers and architects, embedded in your team for as long as you need them.
          </SectionHead>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {staffingServices.map((s, i) => (
              <Reveal key={s.id} delay={i * 90}><StaffCard role={s} index={i} className="h-full" /></Reveal>
            ))}
          </div>
        </div>
      </section>

      <SectionRule index="03" label="Contact" />
      <CTASection title="Need something specific?" />
    </main>
    <Footer />
  </>
);

export default ServicesPage;
